import { render, staticRenderFns } from "./Dashboard.view.vue?vue&type=template&id=13f23f70"
import script from "./Dashboard.view.vue?vue&type=script&lang=js"
export * from "./Dashboard.view.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.view.vue?vue&type=style&index=0&id=13f23f70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports